import { Injectable } from "@angular/core";
import { formatDate } from "@angular/common";
import { convertEpochToReadableISTDateTime } from "./date-time-utils";
import { DateUtils } from "./date-utils";
import { TableDataType, TableMeta } from "../models/table-meta.interface";
import { AdvancedFilterFieldInfo } from "../models/advanced-filter-config.interface";
import { TableListRequest } from "../models/table-list-request.interface";
import { IdName } from "../models/id-name.interface";

@Injectable({
  providedIn: "root"
})
export class CommonUtils {

  static formatData(value: any, dataType: string): string {
    if (value === undefined || value === null) {
      return "";
    }
    const type = dataType?.toUpperCase();

    if (type === "DATETIME_EPOCH") {
      return convertEpochToReadableISTDateTime(value);
    } else if (type === "DATE") {
      return DateUtils.formatDate(value, "dd-MM-yyyy");
    } else if (type === "DATETIME") {
      return DateUtils.formatDate(value, "dd/MM/yy hh:mm a");
    } else if (type === "BOOLEAN") {
      return value ? "Yes" : "No";
    } else if (type === "ARRAY" && Array.isArray(value)) {
      return value.join(", ");
    }
    return value;
  }

  static getNestedValue(obj: any, path: string): any {
    if (!path.includes(".")) {
      return obj[path];
    }
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  }

  static getFilterFieldList(fieldInfo: any[]): AdvancedFilterFieldInfo[] {
    return fieldInfo.map((fieldInfo: any) => ({
      ...fieldInfo,
      operatorToFilterMap: fieldInfo.operatorToFilterMap
        ? new Map(Object.entries(fieldInfo.operatorToFilterMap))
        : undefined
    }));
  }

  static deepCopyJson(json: any) {
    return JSON.parse(JSON.stringify(json));
  }

  static isNotNil(val: any) {
    return val !== undefined && val !== null;
  }

  static buildIdFilterRequest(ids: string[]) : TableListRequest {
    return {
      where: {
        filterConditions: [
          {
            name: 'ID_CONTAINS',
            alias: 'ID_CONTAINS',
            value: ids
          }
        ],
        expression: 'ID_CONTAINS'
      },
      limit: ids.length,
      page: 0
    };
  }

  static toIDName(formValue: any): IdName | undefined {
    if (formValue?.key && formValue?.value) {
      return { id: formValue.key, name: formValue.value };
    }
    return undefined;
  }

}
